ixModuleRouting("impactx.clientcompany", {
    "/clientcompany/list": {
        template: "<ixa-client-company-list></ixa-client-company-list>",
        process: "ClientCompanyList",
        workspace: "admin",
    },
});
